import { useAuth } from "./AuthContext";

interface CanProps {
  perform: string | string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const Can = ({ perform, children }: CanProps) => {
  const { hasPermission } = useAuth();

  return hasPermission(perform) ? <>{children}</> : null;
};
